/* istanbul ignore file */
import React from 'react';
import { WysiwygInput, WysiwygInputProps } from 'framework/form';

const VacancyWysiwygInput = ({ ...props }: WysiwygInputProps) => {
  const editorConfig = ['bold', '|', 'bulletedList', 'numberedList', '|', 'heading'];

  return <WysiwygInput editorConfig={editorConfig} {...props} />;
};

export default VacancyWysiwygInput;
